import React from 'react';
import styles from './Features.module.css';

const Features: React.FC = () => {
  return (
    <section className={styles.features} id="evenements">
      <div className={styles.container}>
        <div className={styles.h2Container}>
          <h2 className={styles.heading}>
            <span className={styles.headingBlack}>BRANDS2BUYERS : </span>
            THE PREMIER B2B COMMERCE EVENT
          </h2>
        </div>

        <p className={styles.paragraph}>
          <span className={styles.brandName}>Brands2Buyers</span>, un événement exclusif rassemble{' '}
          <strong className={styles.pink}>50 décideurs de haut niveau</strong>{' '}
          issus de divers secteurs pour explorer les dernières stratégies, outils
          et solutions visant à moderniser les opérations commerciales et stimuler
          la croissance.
        </p>

        <p className={styles.paragraph}>
          <span className={styles.brandName}>Brands2Buyers</span>, l'événement conçu pour des échanges
          enrichissants entre{' '}
          <strong className={styles.pink}>marques et acheteurs</strong>{' '}
          à travers des conférences inspirantes, des sessions interactives et des
          opportunités de networking.
        </p>
      </div>
    </section>
  );
};

export default Features;
